// ** Initial State
const initialState = {
  allData: [],
  data: [],
  total: 1,
  params: {},
  selectedBulletin: null,
  errors: false,
  block: false
}

const bulletins = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_DATA_BULLETINS':
      return { ...state, allData: action.data }
    case 'GET_DATA_BULLETINS':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params, 
        block: false
      }
    case 'GET_BULLETIN':
      return { ...state, selectedBulletin: action.selectedBulletin, block: false }
    case 'ADD_BULLETIN':
      return { ...state, data: action.data, block: false }
    case 'EDIT_BULLETIN':
      return { ...state, errors: action.errors, block: false }
    case 'BLOCK':
      return { ...state, block: true }
    case 'UNBLOCK':
      return { ...state, block: false }
    case 'DELETE_BULLETIN':
      return { ...state, block: false }
    default:
      return { ...state }
  }
}
export default bulletins
